<template>
    <b-tab :title="$store.state.localization.data.mainPage.fuelTankCard.fuelDensitySensorTabLabel">
      <b-form-checkbox v-model="sensorEnabled" switch>
        {{ $store.state.localization.data.mainPage.fuelTankCard.fuelDensitySensorEnabledLabel }}
      </b-form-checkbox>
      <b-form-group
        label-cols-sm="9"
        label-cols-lg="9"
        content-cols-sm
        content-cols-lg="9"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelDensitySensorInputLabel"
        label-for="input-horizontal"
      >
      <b-form-select
        v-model="sensorInput"
        style="font-size: 13px"
        :disabled="!sensorEnabled"
        :options="sensorInputs"
      ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="9"
        label-cols-lg="9"
        content-cols-sm
        content-cols-lg="9"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelDensitySensorInitDensityLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="0"
          max="1"
          step="0.001"
          v-model="initDensity"
          style="font-size: 13px"
          :disabled="!sensorEnabled"
          :state="isValidInitDensity"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="9"
        label-cols-lg="9"
        content-cols-sm
        content-cols-lg="9"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelDensitySensorInitLevelLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="0"
          max="1000000000000"
          v-model="initLevel"
          style="font-size: 13px"
          :disabled="!sensorEnabled"
          :state="isValidInitLevel"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="9"
        label-cols-lg="9"
        content-cols-sm
        content-cols-lg="9"
        :label="$store.state.localization.data.mainPage.fuelTankCard.fuelDensitySensorStepLabel"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="0"
          max="100000"
          v-model="step"
          style="font-size: 13px"
          :disabled="!sensorEnabled"
          :state="isValidStep"
        ></b-form-input>
      </b-form-group>
    </b-tab>
  </template>

<script>
export default {
  name: "FuelDensitySensorTab",
  props: {
    fuelTankCard: Object,
  },
  data() {
    return {
      sensorEnabled: false,
      sensorInput: 0,
      initDensity: 0,
      isValidInitDensity: null,
      initLevel: 0,
      isValidInitLevel: null,
      step: 0,
      isValidStep: null
    };
  },
  computed: {
    sensorInputs() {
      const options = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.fuelTankCard
          .fuelDensitySensorInputsDropdown.length;
        i++
      ) {
        options.push({
          value: i,
          text: this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelDensitySensorInputsDropdown[i],
        });
      }
      return options;
    },
  },
  created() {
    if (!this.fuelTankCard.densitySensorInput) {
      return;
    }

    this.sensorEnabled = true;

    for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.fuelTankCard
          .fuelDensitySensorInputsDropdown.length;
        i++
      ) {

        if (this.$store.state.localization.data.mainPage.fuelTankCard
            .fuelDensitySensorInputsDropdown[i] == this.fuelTankCard.densitySensorInput) {
              this.sensorInput = i;
              break;

        }
      }

      this.initDensity = this.fuelTankCard.densitySensorInitDensity;
      this.initLevel = this.fuelTankCard.densitySensorInitLevel;
      this.step = this.fuelTankCard.densitySensorStep;
  },
  methods: {
    getSensorSettings() {
      if (this.sensorEnabled) {
        return {
          sensorEnabled: this.sensorEnabled,
          sensorInput: this.$store.state.localization.data.mainPage.fuelTankCard
              .fuelDensitySensorInputsDropdown[this.sensorInput],
          initDensity: this.initDensity,
          initLevel: this.initLevel,
          step: this.step
        }
      } else {
        return {
          sensorEnabled: this.sensorEnabled,
          sensorInput: null,
          initDensity: 0,
          initLevel: 0,
          step: 0
        }
      }
    },
    validate() {
      this.isValidInitDensity = null;
      this.isValidInitLevel = null;
      this.isValidStep = null;
      
      if (!this.sensorEnabled) {
        return true
      }
      
      let isValid = true;

      if (!this.initDensity || this.initDensity <= 0) {
        this.isValidInitDensity= false;
        isValid = false;
      }
      
      if (!this.initLevel || this.initLevel <= 0) {
        this.isValidInitLevel = false;
        isValid = false;
      }
      
      if (!this.step || this.step <= 0) {
        this.isValidStep = false;
        isValid = false;
      }

      return isValid;
    }
  },
};
</script>

